import { EffectObject, EffectsMap } from 'use-effect-reducer';
import { PostEditorState } from '../../../models/post-editor';
import { PostEditorAction } from './PostEditorActions';
import { Dispatch } from 'react';
import { showToast } from '../../../helpers/showToast';
import { mediaWithDeferredUploadEffect, mediaOnUploadCallbackEffect } from './effects/media.effect';
import { submitEditorEffect } from './effects/submitEditor.effect';
import { expandPostGroupEffect } from './effects/expandPostGroup.effect';

export type PostEditorEffect = EffectObject<PostEditorState, PostEditorAction>;
export type PostEditorEffectArgs = (
  state: PostEditorState,
  effect: PostEditorEffect,
  dispatch: Dispatch<PostEditorAction>
) => void;

const showErrorToastEffect: PostEditorEffectArgs = () => {
  showToast({
    severity: 'error',
    summary: 'Post Editor Failure',
    detail: 'Post Editor Action could not be dispatched.'
  });
};

export const postEditorEffects: EffectsMap<PostEditorState, PostEditorAction, PostEditorEffect> = {
  expandPostGroupEffect,
  mediaWithDeferredUploadEffect,
  mediaOnUploadCallbackEffect,
  showErrorToastEffect,
  submitEditorEffect
};
